<template>
    <div class="reportBox">
        <Modal
            :value="showModel"
            :title="$t('productManage.evaluateModel.title')"
            :footer-hide="true"
            :mask-closable="false"
            @on-cancel="cancel"
            @on-visible-change="openOrClose"  :styles="{'min-width':'900px'}">
    
         
    
            <div  class="search-div flexC">
                <!-- <div class="search-div-item">
                    <SearchSelectRecycle
                      refName="devideAttrRef" 
                      ref="devideAttrRef" 
                      :showPage="true" 
                      :errorShow="true" 
                      :selectUrlQuery="{'serialNumber':editFormData.serialNumber}" 
                      :url="searchDeviceAllAttrUrl" 
                      labelName="keyNameText"
                      isMultiple='2'  
                      valName="id"
                      keyword="keyNameText" 
                      :labelInValue="true" 
                      :placeholderText="$t('selectPlaceholder')" 
                       @setSelected="setSelectValNew($event)"></SearchSelectRecycle>
                 </div> -->
                <div class="search-div-item">
                    <Button type="info" @click="searchItem"  icon="ios-search" style="margin-left:20px;width:96px;border-radius: 10px;">{{$t('search')}}</Button>
                 </div>
            </div>
          
            <Table  max-height="510" :border="true" :columns="titleName" :data="tableList.tableData" :loading="loading"></Table>
    
            <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :page-size-opts="[10,20,30,50,100]" placement="top" class="pages"/>
    
            
        </Modal>
    </div>
    </template>
    <script>
    /**
     * 弹框，设备移动组织
     * 
     * @param showModel boolean 对话框开关 true false
     * @param fn function 回调函数
     * @param type Number 类型 1添加 2编辑
     * @param editFormData Object 编辑时的数据
     */
    import common from '@/common/common';
    import moment from 'moment';
    import { mapState } from 'vuex'
    // import SearchSelectRecycle from './selectListRecycleReport.vue';  //20220415
    import { render } from 'less';
    import { cloneDeep } from 'lodash';
        export default {
            props: {
                showModel: Boolean,
                fn:Function,
                type:Number,
                editFormData:Object
            },
            name: "Model3",
            components: {
                // SearchSelectRecycle
            },
            data() {
                return {   
                    searchDeviceAllAttrUrl: this.config.urlArray.getDeviceAllAttr,
                    totalNum:'20',
                    loading:false,
                    tableList:{//表格组
                        hasSelectData:{},//已选中的行的数据
                        tableData: []//表格数据
                    },
                    disabled: false,//禁用确定按钮
                    title: '',//弹框标题
                    formData: {//表单数据
                        loraEUI:'',
                        identifier:'',
                        commandKey:'',
                        commandKeyType:''
                    },
                    page:{//分页排序
                        total:0,//总条数
                        pageSize:10,//每页条数
                        current:1,//当前页
                        key:'created_at',
                        order:'desc'
                    },
                    formatType:'',
                    keyListObj:{},
                    attrArray:[]
                }
            },
            computed:{
                ...mapState(['local']),
                ruleCustom(){
                    return {//验证
                        deviceGroupId: [
                            {required: true, message: this.$t('required'),trigger: 'change' },
                        ]
                    }
                },
                titleName(){
                    return [
                        // {
                        //     title: this.$t('productManage.evaluateModel.information'),
                        //     key: 'id',
                        //     with: 120,
                        //     render: (h, params) => {
                        //         let that = this
                        //         return h('div',{
                        //                  style:{
                                           
                        //                  }
                        //              },params.row.identifier
                        //         )
                               
                        //     }
                        // },
                        {
                            title: this.$t('productManage.evaluateModel.information'),
                            key: 'identifierValue',
                            minWidth: 200,
                            render: (h, params) => {
                                let that = this
                                let res = params.row.resVal?params.row.resVal: params.row.identifierValue
                                return h('div',{
                                        attrs:{
                                           title:res,
                                        },
                                     },res
                                )
                               
                            }
                        },
                        
                        {
                            title: this.$t('setting.registerTime'),
                            key: 'createDate',
                            width: 200,
                            render:(h, params)=>{
                                let stext = params.row.createDate?moment(params.row.createDate*1).format('YYYY-MM-DD HH:mm:ss'):''
                                 return h('div',stext || '')
                            }
                        },
                        {
                            title: this.$t("orderManage.titleName.Operation"),
                            minWidth: 120,
                            key: "id",
                            render: (h, params) => {
                                let that = this;
                                return h('i-Switch', {
			          		      props: {
			          		      	size: 'large',
			          		      	value: params.row.openSmsStatus
			          		      },
                                    scopedSlots: {
                                      open: () => h('span', that.$t("productManage.evaluateModel.disclosure")),
                                      close: () => h('span', that.$t("productManage.evaluateModel.shield"))
                                    },
                                    on:{
                                        'on-change':(value)=>{
                                            that.changeSwitch(value,params.row)
                                        }
                                    }
			          		    })
                            },
                        },
                     ]
                } 
    
            },
            mounted(){
               
            },
            methods: {
                changeSwitch(val,item){//修改switch
                    let getData = {
                        openSmsStatus:val,
                        id:item.id
                    }
                    // this.axios.post(this.config.urlArray.openSmsStatus,getData).then((result) => {
                    //     common.ajaxMsg(result.data,true,()=>{
                    //     });
                    // }).catch((err) => {
                    //     // common.msg('error','获取失败',()=>{})
                    // });
                },
              
                searchItem(){ //搜索
                    this.loading = true
                    this.page.current = 1
                    this.page.pageSize = 10
                    
                    this.formData.loraEUI = this.editFormData.serialNumber
                    this.getData()
                },
                getData(changeType=0) {//获取数据 ,changeType为0代表首次获取数据，为1代表切换分页或者显示条数
                    let params= {
                            page: this.page.current,
                            limit: this.page.pageSize,
                            sortfield: this.page.key,
                            ascDesc: this.page.order,
                            dealerId:this.selectId,
                            loraEUI:this.formData.loraEUI
                        }
        
                    this.axios.post(this.config.urlArray.getDeviceRecordAndMessage, params).then((result) => {
                        // common.ajaxMsg(result.data);
                        let resData = result.data.data.recordMessageList || []
                        //处理数组
                        this.tableList.tableData  = resData
                        this.page.total = result.data.data.meta.count
                        this.loading = false
                    }).catch((err) => {
                        // common.msg('error','获取失败',()=>{})
                    });
                },
                async openOrClose(value) {
                    if(value === true) {
                        // this.$nextTick(()=>{//select赋值，图片赋值
                        //     this.$refs.devideAttrRef.getData()
                        // });   
                    //   await this.getAllAttr()
                      await this.searchItem()
                    } else { 
                        this.resetForm();//重置表单
                        // this.$refs.devideAttrRef.clearVal();
                    }
                },
                changePage(nowpage) {//切换分页
                    this.page.current = nowpage;
                    this.getData(1);
                },
                changeSize(nowSize) {//切换每页显示条数
                    this.page.pageSize = nowSize
                    this.page.current = 1
                    this.getData(1)
                },
                clearTable() { //删除后清空编辑数据 与按钮状态
                    this.page.current = 1
                    this.page.pageSize = 10
                    this.page.total = 0
                    this.tableList.tableData = []
                },
                cancel() {//对话框关闭
                    this.resetForm()
                    this.clearTable()
                    this.$emit('update:showModel',false);
                },
                resetForm() {//重置表单
                    this.disabled = false;
                    this.loading = false
                    this.formatType = ''
                    // this.titleName = []
                    this.keyListObj = {}
                    Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                    this.$emit('update:showModel',false);
                }
            }
        }
    </script>
    <style lang="less" scoped>
    /deep/  .ivu-table-body{
        max-height: 480px !important;
    }
    </style>
    
    